import { IChannel } from '@giphy/js-types'
import { create } from 'zustand'

type Store = {
    [id: string]: IChannel[]
}

const initialState: Store = {}

export const useDataStore = create<Store>()((_) => initialState)

export const updateChannelChildren = (channelId: string | number, channels: IChannel[]): void => {
    useDataStore.setState((state) => ({ ...state, [channelId]: channels }))
}

export const getChannelChildren = (channelId: string | number): IChannel[] => {
    return useDataStore.getState()[channelId] || []
}

export const useChannelChildren = (channelId: string | number, defaultC: IChannel[] = []): IChannel[] => {
    return useDataStore((state) => state[channelId]) || defaultC
}
